export default {
  head: {
    title: 'Customer Validation operations billing',
    action: {
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search Customer Validation billing operation'
    },
    details: {
      title: 'Search Customer Validation billing operation'
    }
  }
};
